// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"12":"profiler","728":"datadog-rum","777":"recorder"}[chunkId] + "." + {"12":"00d6c03a","728":"cb9d50c5","777":"f3b70bc7"}[chunkId] + ".chunk.js";
};